import { render, staticRenderFns } from "./ProjectHighlight.vue?vue&type=template&id=1ebf42aa&scoped=true"
import script from "./ProjectHighlight.vue?vue&type=script&lang=js"
export * from "./ProjectHighlight.vue?vue&type=script&lang=js"
import style0 from "./ProjectHighlight.vue?vue&type=style&index=0&id=1ebf42aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebf42aa",
  null
  
)

export default component.exports